module.exports = __webpack_public_path__ + "static/media/win.8bb0bd4a.mp3";